import * as qs from "app/lib/helperjs";
import {Amount} from "app/model/amount";
import {find} from 'lodash';

const PUBLISHER_ELEMENT_CLASS = 'calculator-publisher-value';

export const calculatorPublisherInit = (calculator) => {
    const markdownElementTag = 'calculator';
    const elements = qs.querySelectorAll(markdownElementTag);

    elements.forEach((element) => {
        const validHTMLElement = qs.createElement('span', {
            'class': PUBLISHER_ELEMENT_CLASS,
            'data-target': element.outerText.toLowerCase(),
        });

        element.innerHTML = '';
        element.append(validHTMLElement);
        element.outerHTML = element.innerHTML;
    });

    calculatorPublisher(calculator);
};

export const calculatorPublisher = (calculator) => {
    const publisherElements = `span.${PUBLISHER_ELEMENT_CLASS}`;
    const elements = qs.querySelectorAll(publisherElements);

    if (!calculator) {
        return;
    }

    elements.forEach((element) => {
        const target = element.getAttribute('data-target');
        let calculatorProp = find(calculator, (v, k) => k.toLowerCase() === target);

        if (!['fee'].includes(target)) {
            calculatorProp = null;
        }

        if (calculatorProp instanceof Amount) {
            calculatorProp = calculatorProp.toString;
        }

        element.innerHTML = calculatorProp || '';
    });
};
